import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { json } from 'react-router-dom';
import { openNotification } from 'src/components/helpers/notification';
import ax from 'src/store/config';
import axFile from 'src/store/configFile';


const initialState = {
    clubDocumentsList: null,
    clubDocumentsListLoading: false
};

export const clubDocumentsAction = createAsyncThunk(
  'clubDocumentsAction',
  async (payload, { dispatch }) => {
    dispatch(setClubDocumentsListLoading(true))
    try {
        let data;
        const url = '/api/documents/clubs';
        switch (payload.flag) {
            case 'get':
                ({ data } = await ax.get(url, { params: payload.value }))
                data && dispatch(setClubDocumentsListLoading(false))
                return data

            // case 'post':
            //     ({ data } = await ax.post(url, payload.value))
            //     data && openNotification({
            //         type: 'success',
            //         message: `Тип клуба успешно отредактирован`
            //     })
            //     break;

            case 'put':
                ({ data } = await ax.put(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Документ успешно отредактирован`
                })
                break;

            // case 'delete':
            //     ({ data } = await ax.delete(url, { params: payload.value }))
            //     data && openNotification({
            //         type: 'success',
            //         message: `Тип клуба успешно удален`
            //     })
            //     break;

            default:
                break;
        }
    } catch (error) {
        dispatch(setClubDocumentsListLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

export const editFile = createAsyncThunk("editFile", async (payload) => {
    for (let [key, value] of payload.entries()) {
        console.log(key, value);
    }
    try {
        const url = '/api/documents/clubs'
        await axFile.put(url, payload)
        openNotification({
            type: 'success',
            message: `Документ успешно отредактирован`
        })
        } 
    catch (err) {
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
    }
})

const ClubDocumentsSlice = createSlice({
    name: 'clubDocuments',
    initialState,
    reducers: {
        setClubDocumentsListLoading: (state, action) => {
            state.clubDocumentsListLoading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(clubDocumentsAction.fulfilled, (state, action) => {
            state.clubDocumentsList = action.payload
        })
    }
});

export const { setClubDocumentsListLoading } = ClubDocumentsSlice.actions;

export default ClubDocumentsSlice.reducer